import React, { useState, useEffect } from 'react';
import PageDescription from "../admin/DataAnalyst/sections/PageDescription";
import AppTour from '../../components/AppTour/AppTour';
import { accountSetupTourSteps } from '../../components/AppTour/ModuleTourSteps';

const ACCOUNT_SETUP_URL = 'https://upncomer-media.s3.us-west-2.amazonaws.com/distribution/account-setup/'

export default function AccountSetup() {
    const [runTour, setRunTour] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const startIfHash = () => {
            const hash = window.location.hash || '';
            if (hash === '#start-tour') {
                setRunTour(true);
            }
        };

        startIfHash();
        const onHashChange = () => startIfHash();
        window.addEventListener('hashchange', onHashChange);
        return () => window.removeEventListener('hashchange', onHashChange);
    }, [setRunTour]);

    const imageCount = 15;
    const images = Array.from({ length: imageCount }).map((_, i) => {
        const idx = i + 1;
        return `${ACCOUNT_SETUP_URL}account-setup-${idx}.png`;
    });

    return (
        <div className="DataAnalyst-page py-5">
            <div className="container max-w-full">
                <PageDescription
                    title="Distribution Account Setup Demo"
                    description="UpNComer Distribution Account Setup Demo"
                />

                <div className="performance-section relative bg-theme_clr1 rounded-xl mb-5 p-4 lg:px-5 pt-[26px] pb-[30px]" data-tour="performance-section">
                    <div className="flex flex-col gap-4">
                        {images.map((img, idx) => (
                            <div key={idx} data-tour={`account-setup-${idx + 1}`} className="w-full rounded-lg overflow-hidden">
                                <img src={img} alt={`Account setup ${idx + 1}`} className="w-full h-auto block" loading="lazy" />
                            </div>
                        ))}
                    </div>
                </div>

                <AppTour tourSteps={accountSetupTourSteps} runTour={runTour} setRunTour={setRunTour} />
            </div>
        </div>
    )
}